var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDreamLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6977 0H0V11.999C2.47283 11.999 4.59423 13.51 5.50077 15.6635C5.86231 16.5222 6.70801 17.0734 7.63574 17.0734C8.56356 17.0734 9.40927 16.5222 9.7708 15.6635C10.6773 13.51 12.7987 11.999 15.2716 11.999C18.569 11.999 21.2421 14.6857 21.2421 18C21.2421 21.3143 18.569 24.001 15.2716 24.001C12.7987 24.001 10.6773 22.49 9.7708 20.3365C9.40927 19.4777 8.56356 18.9265 7.63574 18.9265C6.70801 18.9265 5.86231 19.4777 5.50077 20.3365C4.59423 22.49 2.47283 24.001 0 24.001V36H14.6977C24.5883 36 32.6063 27.9411 32.6063 18C32.6063 8.05884 24.5883 0 14.6977 0Z",
    fill: "url(#paint0_radial_1071_237)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6977 0H0V11.999C2.47283 11.999 4.59423 13.51 5.50077 15.6635C5.86231 16.5222 6.70801 17.0734 7.63574 17.0734C8.56356 17.0734 9.40927 16.5222 9.7708 15.6635C10.6773 13.51 12.7987 11.999 15.2716 11.999C18.569 11.999 21.2421 14.6857 21.2421 18C21.2421 21.3143 18.569 24.001 15.2716 24.001C12.7987 24.001 10.6773 22.49 9.7708 20.3365C9.40927 19.4777 8.56356 18.9265 7.63574 18.9265C6.70801 18.9265 5.86231 19.4777 5.50077 20.3365C4.59423 22.49 2.47283 24.001 0 24.001V36H14.6977C24.5883 36 32.6063 27.9411 32.6063 18C32.6063 8.05884 24.5883 0 14.6977 0Z",
    fill: "url(#paint1_radial_1071_237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1071_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.9687 31 -28.0776 19.9545 3.30701 3.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589342,
    stopColor: "#F7A1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97D5FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1071_237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.06647e-06 8 -8.07817 0.0113133 15.4 19.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#000D26",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D26",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreamLogoIcon);
export default __webpack_public_path__ + "static/media/dream-logo-icon.6c66fe9b550b84d9c06692cd04f0f5d7.svg";
export { ForwardRef as ReactComponent };